"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TfPropertyTypeError = exports.TfTypeError = void 0;
exports.getValueTypeName = getValueTypeName;
exports.tfJSON = tfJSON;
exports.tfCustomError = tfCustomError;
exports.tfSubError = tfSubError;
const native_js_1 = __importDefault(require("./native.js"));
function getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/u)[1];
}
function getValueTypeName(value) {
    return native_js_1.default.Nil(value)
        ? ''
        : getTypeName(value.constructor);
}
function getValue(value) {
    if (native_js_1.default.Function(value))
        return '';
    if (native_js_1.default.String(value))
        return JSON.stringify(value);
    if (value && native_js_1.default.Object(value))
        return '';
    return value;
}
function captureStackTrace(e, _t) {
    if (Error.captureStackTrace) {
        Error.captureStackTrace(e, _t);
    }
}
function tfJSON(type) {
    if (native_js_1.default.Function(type)) {
        return type.toJSON
            ? type.toJSON()
            : getTypeName(type);
    }
    if (native_js_1.default.Array(type))
        return 'Array';
    if (type && native_js_1.default.Object(type))
        return 'Object';
    return type === undefined ? '' : type;
}
function tfErrorString(type, value, valueTypeName) {
    const valueJson = getValue(value);
    return ('Expected ' +
        tfJSON(type) +
        ', got' +
        (valueTypeName === '' ? '' : ' ' + valueTypeName) +
        (valueJson === '' ? '' : ' ' + valueJson));
}
class TfTypeError extends Error {
    __type;
    __value;
    __valueTypeName;
    constructor(type, value, valueTypeName) {
        valueTypeName = valueTypeName || getValueTypeName(value);
        super(tfErrorString(type, value, valueTypeName));
        this.__type = type;
        this.__value = value;
        this.__valueTypeName = valueTypeName;
    }
}
exports.TfTypeError = TfTypeError;
function tfPropertyErrorString(type, label, name, value, valueTypeName) {
    let description = '" of type ';
    if (label === 'key')
        description = '" with key type ';
    return tfErrorString('property "' + tfJSON(name) + description + tfJSON(type), value, valueTypeName);
}
class TfPropertyTypeError extends Error {
    __label;
    __property;
    __type;
    __value;
    __valueTypeName;
    constructor(type, property, label, value, valueTypeName) {
        let message;
        if (type) {
            valueTypeName = valueTypeName || getValueTypeName(value);
            message = tfPropertyErrorString(type, label, property, value, valueTypeName);
        }
        else {
            message = 'Unexpected property "' + property + '"';
        }
        super(message);
        this.__label = label;
        this.__property = property;
        this.__type = type;
        this.__value = value;
        this.__valueTypeName = valueTypeName;
    }
}
exports.TfPropertyTypeError = TfPropertyTypeError;
function tfCustomError(expected, actual) {
    return new TfTypeError(expected, {}, actual);
}
function tfSubError(e, property, label) {
    if (e instanceof TfPropertyTypeError) {
        property = property + '.' + e.__property;
        e = new TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    }
    else if (e instanceof TfTypeError) {
        e = new TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    }
    captureStackTrace(e);
    return e;
}
